<template>
<!-- eSIM Device Check Modal -->
<div class="modal fade esim-device-check-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="dialog">
    <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title"> Geräte-Check</h2>
        <button type="button" aria-label="Close" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <slot name="header">
            <p>Du bist dir nicht sicher, ob dein Gerät eSIM-fähig ist? Dann kannst du das hier ganz easy nachschauen. Wenn dein Gerät hier
                aufgelistet ist, kannst du sicher sein, dass es mit der eSIM funktioniert.</p>
          </slot>
          <b-form-group class="device-check mt-5 mb-5">
            <b-row>
                <b-col md="6" sm="12" class="mb-2">
                <label class="mandatory"><slot name="deviceTypeLabel">Gerätetyp</slot></label>
                <b-form-select
                    v-model="deviceType"
                    required
                    :options="deviceTypeOptions"
                    @change="filterDevices"
                ></b-form-select>
                </b-col>
                <b-col md="6" sm="12">
                <label class="mandatory"><slot name="manufacturerLabel">Hersteller</slot></label>
                <b-form-select
                    v-model="manufacturer"
                    required
                    :options="manufacturerOptions"
                    @change="filterDevices"
                ></b-form-select>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="12" sm="12">
                <label class="mandatory"><slot name="deviceSearchLabel">Gerät</slot></label>

                <div class="suggestion-input">
                    <b-form-input
                        type="text"
                        v-model="deviceSearch"
                        required
                        autocomplete="off"
                        placeholder="z.B. iPhone 13 Pro"
                        @focus="showSuggestion"
                        @blur="hideSuggestion"
                        @input="filterSuggestion"
                        >
                    </b-form-input>
                    <ul v-if="isSuggestionVisible">
                        <li v-for="item in deviceOptions" :key="item.id" :item="item" @click="selectItem(item)">
                        {{ item }}
                        </li>
                    </ul>
                </div>
                </b-col>
            </b-row>
          </b-form-group>
          <p class="after-device-check-txt mb-5">
            <slot name="afterDeviceCheckTxt">Dein Gerät ist hier nicht aufgelistet? Dat muss noch nichts heißen. Frag zur Sicherheit einfach bei deinem Gerätehersteller nach,
              ob dein Gerät eSIM-fähig ist.</slot>
          </p>
        </div>
    </div>
    </div>
</div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

export default {
  name: 'ESimDeviceCheckModal',
  components: {},
  data () {
    return {
      deviceType: '',
      manufacturer: '',
      deviceSearch: '',
      DeviceTypes: {
        LAPTOP: 'Laptop',
        PHONE: 'Smartphone',
        TABLET: 'Tablet',
        UNKNOWN: 'Unbekannt'
      },
      isSuggestionVisible: false,
      articleGroups: {
        articleGroups: [],
        articleLists: {
          deviceTypes: [],
          manufacturers: []
        }
      },
      filteredArticleGroups: []
    }
  },
  computed: {
    manufacturerOptions: function () {
      return this.articleGroups.articleLists.manufacturers.map(item => {
        return item.manufacturer
      })
    },
    deviceTypeOptions: function () {
      return this.articleGroups.articleLists.deviceTypes.map(item => {
        return this.DeviceTypes[item.deviceType]
      })
    },
    deviceOptions: {
      get: function () {
        return this.articleGroups.articleGroups.map(item => {
          return item.name
        })
      },
      set: function (newValue) {
        this.setDeviceOptions(newValue)
      }
    }
  },
  methods: {
    filterDevices () {
      let devices = [...this.articleGroups.articleGroups]

      if (this.deviceType.length > 0) {
        const deviceTypeKey = Object.keys(this.DeviceTypes).find(key => this.DeviceTypes[key] === this.deviceType)

        devices = devices.filter(item => {
          return item.deviceType === deviceTypeKey
        })
      }

      if (this.manufacturer.length > 0) {
        devices = devices.filter(item => {
          return item.manufacturer === this.manufacturer
        })
      }
      this.filteredArticleGroups = devices
      this.deviceOptions = devices.map(item => {
        return item.name
      })
    },
    filterSuggestion () {
      const matchedItems = []
      const userInput = this.deviceSearch.toLowerCase()

      if (this.filteredArticleGroups.length === 0) {
        this.filteredArticleGroups = [...this.articleGroups.articleGroups]
      }
      const itemsCount = this.filteredArticleGroups.length

      for (let i = 0; i < itemsCount; i++) {
        const item = this.filteredArticleGroups[i]

        if (item.name.toLowerCase().search(new RegExp(userInput)) !== -1) {
          matchedItems.push(item.name)
        }
      }
      this.deviceOptions = matchedItems
    },
    setDeviceOptions (items) {
      this.deviceOptions.length = 0
      for (var item of items) {
        this.deviceOptions.push(item)
      }
    },
    selectItem (item) {
      this.deviceSearch = item
      document.getElementsByClassName('after-device-check-txt')[0].innerHTML = `Dein Gerät ist eSIM-fähig.
      Sauber! Du kannst die eSIM ohne Probleme bestellen.`
    },
    showSuggestion () {
      this.isSuggestionVisible = true
    },
    hideSuggestion () {
      setTimeout(() => { this.isSuggestionVisible = false }, 200)
    }
  },
  mixins: [],
  apollo: {
    articleGroups: function () {
      return wrapQuery(gql`query {
        articleGroups (
            articleFilter: {
            deviceTypes: "LAPTOP,PHONE,ROUTER,TABLET,UNKNOWN",
            eSim: true,
            manufacturer: null,
            simCard: null,
            deviceTypeList: true,
            manufacturerList: true}
        ) {
            articleGroups {
            deviceType
            manufacturer
            name
            supports {
                eSim
                simCard
            }
            }
            articleLists {
                manufacturers {
                    manufacturer
                }
                deviceTypes {
                    deviceType
                }
            }
            success
        }
    }`, this, 'articleGroups'
      )
    }
  }
}
</script>
